import {useParams} from 'react-router-dom';

import {CardBox} from '@shared/components';
import {Header} from '@widgets/common';

import {COLOR__WHITE} from '@/theme/colors';

export const TransactionFullInfoPage = () => {
  const {id} = useParams<{id: string}>();

  return (
    <>
      <Header title={`Transaction ${id}`} mb={2} />

      <CardBox bgcolor={COLOR__WHITE} />
    </>
  );
};
